<template>
  <form class="search-form" action="/search">
    <input type="hidden" name="type" value="article,page,product"/>
    <input type="hidden" name="options[prefix]" value="last"/>
    <div class="input">
      <label class="u-sr-only" for="q">Search</label>
      <search-input ref="searchInput" @keyup="showSearchResults" @focus="openSearchResults" :placeholder="placeholder" v-model="searchValue" :autocomplete="enablePredictiveSearch ? 'off' : 'on'"></search-input>
    </div>
    <fade-transition>
      <div class="search-form__modal-close bg-white" v-if="enablePredictiveSearch && showSearchModal" @click="closeSearchResults">
        <icon name="close" size="12px"></icon>
      </div>
    </fade-transition>
    <v-button class="search-form__submit" label="Search">
      <icon name="search" :size="searchIconSize"></icon>
    </v-button>
    <v-button class="search-form__close" @click="closeClick" label="Close Search" type="button">
      <icon class="color-black" name="close" size="9px"></icon>
    </v-button>
    <predictive-search-modal v-if="enablePredictiveSearch" :searchTerm="searchValue" ref="predictiveSearchModal"></predictive-search-modal>
  </form>
</template>

<script>
import SearchInput from '@/scripts/components/forms/SearchInput.vue'
import PredictiveSearchModal from '@/scripts/components/search/PredictiveSearchModal.vue'
import VButton from '@/scripts/components/buttons/VButton.vue'
import Icon from '@/scripts/components/basic/Icon.vue'
import { FadeTransition } from 'vue2-transitions'

export default {
  name: 'SearchForm',
  components: {
    SearchInput,
    PredictiveSearchModal,
    VButton,
    Icon,
    FadeTransition
  },
  data () {
    return {
      searchValue: '',
      isMounted: false
    }
  },
  props: {
    inputPlaceholder: String,
    searchIconSize: {
      type: String,
      default: '32px'
    },
    enablePredictiveSearch: Boolean
  },
  computed: {
    // cannot use default prop because empty strings
    // get passed from shopify.
    placeholder () {
      return this.inputPlaceholder || 'Search'
    },
    showSearchModal () {
      return this.isMounted ? this.$refs.predictiveSearchModal.showModal : false
    }
  },
  methods: {
    closeClick () {
      if (this.enablePredictiveSearch) {
        this.$refs.predictiveSearchModal.close()
      }
      if (['mobile', 'tablet'].includes(this.$mq)) {
        // this.$refs.searchInput.clearInput()
        this.$emit('close-search')
      } else {
        this.$emit('close-search')
      }
    },
    showSearchResults () {
      if (!this.$refs.predictiveSearchModal) return
      this.$refs.predictiveSearchModal.getSearchResults()
    },
    closeSearchResults () {
      if (!this.$refs.predictiveSearchModal) return
      this.$refs.predictiveSearchModal.close()
    },
    openSearchResults () {
      if (this.searchValue.length <= 0 || !this.$refs.predictiveSearchModal) {
        return
      }
      this.$refs.predictiveSearchModal.show()
    }
  },
  mounted () {
    this.isMounted = true
  }
}
</script>

<style scoped lang="scss">
  .search-form {
    width: 100%;
    height: 88px;
    position: relative;
    background-color: $color-black;
    padding: 24px 16px;
    display: flex;
    align-items: center;

    &__submit {
      position: absolute;
      top: 50%;
      right: 25px;
      left: auto;
      transform: translateY(-50%);
      z-index: 1;
      right: auto;
      left: 22px;
    }

    &__close {
      cursor: pointer;
      display: block;
      position: absolute;
      top: 50%;
      right: 16px;
      transform: translateY(-50%);
      z-index: 1;
      padding-top: 9px;
      padding-right: 16px;
      padding-bottom: 9px;
      padding-left: 4px;
    }

    @include desktop-up {
      background-color: $color-white;
      padding: 0;
      right: 0;
      left: auto;
      max-width: 300px;
      position: absolute;
      width: 100%;
      height: 43px;

      &__submit {
        left: 6px;
      }

      &__close {
        right: 0;
      }
    }

    &__modal-close {
      position: absolute;
      top: 50%;
      right: 72px;
      z-index: 1;
      display: flex;
      padding: 8px;
      border-radius: 50%;
      box-shadow: $drop-shadow--light;
      transform: translateY(-50%);
      cursor: pointer;

      .navbar & {
        display: none;
      }
    }

    .input {
      margin: 0;
      width: 100%;
    }
  }

  /deep/ .button__content {
    display: flex;
  }

  /deep/ .search-input::-webkit-input-placeholder, /* Chrome/Opera/Safari */
  /deep/ .search-input::-moz-placeholder, /* Chrome/Opera/Safari */
  /deep/ .search-input:-ms-input-placeholder,/* Chrome/Opera/Safari */
  /deep/ .search-input:-moz-placeholder { /* Chrome/Opera/Safari */
    color: $color-grey;
  }

  /deep/ .search-input::placeholder {
    color: $color-grey;
  }
</style>
